import WaveformData from 'waveform-data'

async function reduceWaveform(res) {
  const buffer = await res.arrayBuffer()
  const waveformData = new WaveformData(buffer)
  const waveData = waveformData.toJSON().data
  const tempData = [...waveData].map((d) => Math.abs(d)).sort((a, b) => b - a)
  const max = tempData.slice(0, 100).reduce((acc, cur) => acc + cur, 0) / 100
  const min =
    tempData
      .slice(tempData.length - 100, tempData.length)
      .reduce((acc, cur) => acc + cur, 0) / 100
  const normalized = []
  for (let i = 0; i < waveData.length; i += 2) {
    const x = waveData[i]
    const y = waveData[i + 1]
    normalized.push([x / max, y / max])
  }

  const average =
    normalized.reduce(
      (acc, cur) => acc + (Math.abs(cur[0]) + Math.abs(cur[1])) / 2,
      0,
    ) / normalized.length

  const sumSquares = Math.sqrt(
    normalized.reduce((acc, cur) => {
      const amp = Math.max(Math.abs(cur[0]), Math.abs(cur[1]))
      return acc + amp * amp
    }, 0) / normalized.length,
  )

  let drawableData = normalized
  while (drawableData.length > 2500) {
    drawableData = reduceWaveData(drawableData)
  }

  const drawableMin = Math.abs(Math.min(...drawableData.map((d) => d[0])))
  const drawableMax = Math.max(...drawableData.map((d) => d[1]))

  drawableData = drawableData.map((d) => [
    d[0] / drawableMin,
    d[1] / drawableMax,
  ])

  return {
    data: normalized,
    original: waveData,
    min: min / max,
    max,
    average,
    drawableData,
    sumSquares,
  }
}

function reduceWaveData(data) {
  const reduced = []
  for (let i = 0; i < data.length; i += 2) {
    if (data[i + 1]) {
      const x = (Number(data[i][0]) + Number(data[i + 1][0])) / 2
      const y = (Number(data[i][1]) + Number(data[i + 1][1])) / 2
      reduced.push([x, y])
    } else {
      reduced.push([...data[i]])
    }
  }
  return reduced
}

export default reduceWaveform
/*
          const buffer = await response.arrayBuffer()
          const waveformData = new WaveformData(buffer)
          const waveData = waveformData.toJSON().data
          const maxValue = Math.max(...waveData)
          const minValue = Math.abs(Math.min(...waveData))

          const normalized = []
          for (let i = 0; i < waveData.length; i += 2) {
            const x = waveData[i]
            const y = waveData[i + 1]
            normalized.push([
              (x / minValue).toFixed(2),
              (y / maxValue).toFixed(2),
            ])
          }
          return normalized
        },
 */
